module.exports = __webpack_public_path__ + "img/ru.2354931b.svg";